import React, { useContext } from "react"
import { Link } from "react-router-dom"
import Dialog from "@reach/dialog"
import QRCode from "react-qr-code"
import { CopyToClipboard } from "react-copy-to-clipboard"
import { toast } from "react-toastify"
import { UserContext } from "../../HomeApp"
import { own_bandnada_path } from "../../../routes"
import "./ShareBandNadaModal.css"

interface ShareBandNadaModalProps {
  isOpen: boolean
  onDismiss: () => void
}

export const ShareBandNadaModal: React.FC<ShareBandNadaModalProps> = ({
  isOpen,
  onDismiss,
}) => {
  const { user } = useContext(UserContext)

  if (!isOpen || !user) return null

  const isFan = user.band?.band_type === "fan"
  const followTarget = isFan ? "you" : user.band.name

  // Lands a friend on the sharer's own band page with ?follow=true, which
  // auto-pops the registration dialog for logged-out visitors (see
  // BandScreen's own follow-param handling) - same utm_source/utm_medium
  // convention a band's own share button already uses, plus ref= so the
  // sharer still gets referral credit.
  const shareUrl = `${window.location.origin}${user.band.band_path}?follow=true&utm_source=band_header&utm_medium=share&ref=${user.id}`

  return (
    <Dialog
      isOpen={isOpen}
      onDismiss={onDismiss}
      aria-label="Share bandNada"
      className="ShareBandNadaModal__content"
    >
      <button
        className="ShareBandNadaModal__close focus:outline-none"
        onClick={onDismiss}
        type="button"
        aria-label="Close"
      >
        <span className="focus:outline-none text-lg" aria-hidden>
          ×
        </span>
      </button>

      <div className="flex flex-col items-center justify-center text-center px-4">
        <h1 className="font-bold text-xl mb-2">Share bandNada</h1>
        <p className="text-gray-600 text-sm mb-6">
          You get 50 bandNada shares, they get 10, and they follow{" "}
          {followTarget}.
          <br />
          <Link
            to={own_bandnada_path()}
            className="text-blue-600 underline"
            onClick={onDismiss}
          >
            Everyone's an Owner
          </Link>
        </p>

        <div className="bg-white p-4 rounded">
          <QRCode value={shareUrl} size={240} />
        </div>

        <CopyToClipboard
          text={shareUrl}
          onCopy={() =>
            toast.success("Your share URL was copied to your clipboard!", {
              position: "top-center",
              autoClose: 2000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            })
          }
        >
          <button
            type="button"
            className="mt-6 font-bold text-blue-600 focus:outline-none underline"
          >
            Copy Your Share URL
          </button>
        </CopyToClipboard>
      </div>
    </Dialog>
  )
}
